import React from "react";
import { NoteTooltipTableCell } from "MODULES/shared/components";
import { FOLLOW_UP_FEEDBACK } from "MODULES/OutgoingQuotes/constants";
import { get, isEmpty } from "lodash";
import { properCase } from "LIB/formatters/text";
import { shortDateYYandTime } from "LIB/formatters/date";

export default ({ lineItem }) => {
  const followUpFeedback =
    lineItem[FOLLOW_UP_FEEDBACK] &&
    properCase(
      `${lineItem[FOLLOW_UP_FEEDBACK]}${lineItem.internal_note
        ? ":"
        : ""} ${lineItem.internal_note
        ? lineItem.internal_note
        : ""} ${shortDateYYandTime(
        get(lineItem, `internal_note_audit.updated_at`)
      )}`
    );

  const noteProps = {
    note: [followUpFeedback || lineItem.internal_note, lineItem.external_note]
      .filter(f => !isEmpty(f))
      .join(" | "),
    color: isEmpty(lineItem[FOLLOW_UP_FEEDBACK]) ? undefined : "#f44336"
  };
  return <NoteTooltipTableCell {...noteProps} />;
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/OutgoingQuoteNote.jsx